module.exports = "deb62c5987881cd09847fbc6cbf5bf64.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/shrine-challenge-star.png
// module id = 107
// module chunks = 0